export enum roles {
    SystemAdmin = 1,
    ServiceAdmin = 2,
    PartnerAdmin = 3,
    PartnerUsers = 4,
    Employee = 5,
    Payee = 6,
}